import React from 'react';

const Clock = ({ ...rest }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M8 14C4.6862 14 2 11.3138 2 8C2 4.6862 4.6862 2 8 2C11.3138 2 14 4.6862 14 8C14 11.3138 11.3138 14 8 14ZM8.6 8V5H7.4V9.2H11V8H8.6Z"
        fill="#F27B2C"
      />
    </svg>
  );
};

export const crossIcon = (
  <svg width="8" height="8" viewBox="0 0 8 8" fill="none">
    <g clipPath="url(#clip0_12_620)">
      <path
        d="M4.70696 3.99999L7.85351 0.85379C8.04883 0.65847 8.04883 0.341795 7.85351 0.14649C7.65819 -0.0488301 7.34151 -0.0488301 7.14621 0.14649L3.99999 3.29302L0.85379 0.14649C0.65847 -0.0488301 0.341795 -0.0488301 0.14649 0.14649C-0.0488144 0.341811 -0.0488301 0.658485 0.14649 0.85379L3.29302 3.99999L0.14649 7.14621C-0.0488301 7.34153 -0.0488301 7.65821 0.14649 7.85351C0.341811 8.04881 0.658485 8.04883 0.85379 7.85351L3.99999 4.70696L7.14619 7.85351C7.34151 8.04883 7.65819 8.04883 7.85349 7.85351C8.04881 7.65819 8.04881 7.34151 7.85349 7.14621L4.70696 3.99999Z"
        fill="#888888"
      />
    </g>
    <defs>
      <clipPath id="clip0_12_620">
        <rect width="8" height="8" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const filterIcon2 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
  >
    <path
      d="M6.29339 15.1C5.97339 15.1 5.66006 15.02 5.36672 14.86C4.78006 14.5333 4.42672 13.94 4.42672 13.2733V9.74C4.42672 9.40667 4.20672 8.90667 4.00006 8.65333L1.50672 6.01333C1.08672 5.59333 0.766724 4.87333 0.766724 4.33333V2.8C0.766724 1.73333 1.57339 0.9 2.60006 0.9H11.4001C12.4134 0.9 13.2334 1.72 13.2334 2.73333V4.2C13.2334 4.9 12.8134 5.69333 12.4201 6.08667L9.53339 8.64C9.25339 8.87333 9.03339 9.38667 9.03339 9.8V12.6667C9.03339 13.26 8.66006 13.9467 8.19339 14.2267L7.27339 14.82C6.97339 15.0067 6.63339 15.1 6.29339 15.1ZM2.60006 1.9C2.13339 1.9 1.76672 2.29333 1.76672 2.8V4.33333C1.76672 4.58 1.96672 5.06 2.22006 5.31333L4.76006 7.98667C5.10006 8.40667 5.43339 9.10667 5.43339 9.73333V13.2667C5.43339 13.7 5.73339 13.9133 5.86006 13.98C6.14006 14.1333 6.48006 14.1333 6.74006 13.9733L7.66672 13.38C7.85339 13.2667 8.04006 12.9067 8.04006 12.6667V9.8C8.04006 9.08667 8.38672 8.3 8.88672 7.88L11.7401 5.35333C11.9667 5.12667 12.2401 4.58667 12.2401 4.19333V2.73333C12.2401 2.27333 11.8667 1.9 11.4067 1.9H2.60006Z"
      fill="#CDD0D5"
    />
  </svg>
);

export const filterIcon = (
  <svg width="12" height="13" viewBox="0 0 12 13" fill="none">
    <path
      d="M5.82423 12.1058C5.70962 12.1058 5.61305 12.0673 5.53452 11.9901C5.456 11.913 5.41673 11.8169 5.41673 11.702V7.14909L0.68919 1.43117C0.612273 1.3286 0.601225 1.22097 0.656044 1.10826C0.710878 0.995549 0.800447 0.939194 0.924753 0.939194H11.0753C11.1996 0.939194 11.2892 0.995549 11.344 1.10826C11.3989 1.22097 11.3878 1.3286 11.3109 1.43117L6.58336 7.14909V11.702C6.58336 11.8169 6.54491 11.913 6.468 11.9901C6.3911 12.0673 6.29534 12.1058 6.18073 12.1058H5.82423ZM6.00004 6.14751L9.37504 2.02251H2.60421L6.00004 6.14751Z"
      fill="#1C1B1F"
    />
  </svg>
);

export const rightToggleIcon = (
  <svg width="6" height="8" viewBox="0 0 6 8" fill="none">
    <path
      d="M1.39998 7.76921L0.780762 7.14999L3.93076 3.99999L0.780762 0.849991L1.39998 0.230774L5.1692 3.99999L1.39998 7.76921Z"
      fill="#00A0DF"
    />
  </svg>
);

export const filterLayersIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="8"
    viewBox="0 0 12 8"
    fill="none"
  >
    <path
      d="M4.80001 7.6H7.20001V6.4H4.80001V7.6ZM0.600006 0.4V1.6H11.4V0.4H0.600006ZM2.40001 4.6H9.60001V3.4H2.40001V4.6Z"
      fill="#0A0D14"
    />
  </svg>
);

export const plusIcon = (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
    <path
      d="M4.5 9.49998V5.49998H0.5V4.50002H4.5V0.500015H5.49997V4.50002H9.49997V5.49998H5.49997V9.49998H4.5Z"
      fill="#069AD5"
    />
  </svg>
);

export const searchIconWithLongTail = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      d="M11.0282 11.7179L6.84099 7.53075C6.50766 7.80596 6.12433 8.02135 5.69099 8.1769C5.25766 8.33246 4.80937 8.41023 4.34613 8.41023C3.20668 8.41023 2.24234 8.01571 1.45309 7.22667C0.663848 6.43762 0.269226 5.47353 0.269226 4.33438C0.269226 3.19523 0.663748 2.23078 1.45279 1.44103C2.24184 0.6513 3.20594 0.256433 4.34509 0.256433C5.48424 0.256433 6.44868 0.651057 7.23843 1.4403C8.02817 2.22955 8.42304 3.19389 8.42304 4.33333C8.42304 4.8094 8.34313 5.2641 8.18329 5.69743C8.02346 6.13077 7.81021 6.50769 7.54354 6.8282L11.7307 11.0154L11.0282 11.7179ZM4.34613 7.41027C5.2051 7.41027 5.93267 7.11219 6.52883 6.51603C7.12498 5.91988 7.42306 5.19231 7.42306 4.33333C7.42306 3.47436 7.12498 2.74679 6.52883 2.15063C5.93267 1.55448 5.2051 1.2564 4.34613 1.2564C3.48715 1.2564 2.75958 1.55448 2.16343 2.15063C1.56728 2.74679 1.26921 3.47436 1.26921 4.33333C1.26921 5.19231 1.56728 5.91988 2.16343 6.51603C2.75958 7.11219 3.48715 7.41027 4.34613 7.41027Z"
      fill="#1C1B1F"
    />
  </svg>
);
const RightArrow = ({ onClick, style, isDisabled }) => {
  const arrowStyle = isDisabled
    ? { ...style, cursor: 'not-allowed', opacity: 0.5 }
    : style;

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={isDisabled ? null : onClick} // Prevent clicking when disabled
      style={arrowStyle}
    >
      <path
        d="M12 11.25V9L15 12L12 15V12.75H9V11.25H12ZM12 4.5C16.14 4.5 19.5 7.86 19.5 12C19.5 16.14 16.14 19.5 12 19.5C7.86 19.5 4.5 16.14 4.5 12C4.5 7.86 7.86 4.5 12 4.5ZM12 18C15.315 18 18 15.315 18 12C18 8.685 15.315 6 12 6C8.685 6 6 8.685 6 12C6 15.315 8.685 18 12 18Z"
        fill="#525866"
      />
    </svg>
  );
};

const Dots = ({ ...rest }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M4.75 8.5C3.925 8.5 3.25 9.175 3.25 10C3.25 10.825 3.925 11.5 4.75 11.5C5.575 11.5 6.25 10.825 6.25 10C6.25 9.175 5.575 8.5 4.75 8.5ZM15.25 8.5C14.425 8.5 13.75 9.175 13.75 10C13.75 10.825 14.425 11.5 15.25 11.5C16.075 11.5 16.75 10.825 16.75 10C16.75 9.175 16.075 8.5 15.25 8.5ZM10 8.5C9.175 8.5 8.5 9.175 8.5 10C8.5 10.825 9.175 11.5 10 11.5C10.825 11.5 11.5 10.825 11.5 10C11.5 9.175 10.825 8.5 10 8.5Z"
        fill="#525866"
      />
    </svg>
  );
};

const Block = ({ ...rest }) => {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M10 17.5C5.85775 17.5 2.5 14.1423 2.5 10C2.5 5.85775 5.85775 2.5 10 2.5C14.1423 2.5 17.5 5.85775 17.5 10C17.5 14.1423 14.1423 17.5 10 17.5ZM10 16C11.5913 16 13.1174 15.3679 14.2426 14.2426C15.3679 13.1174 16 11.5913 16 10C16 8.4087 15.3679 6.88258 14.2426 5.75736C13.1174 4.63214 11.5913 4 10 4C8.4087 4 6.88258 4.63214 5.75736 5.75736C4.63214 6.88258 4 8.4087 4 10C4 11.5913 4.63214 13.1174 5.75736 14.2426C6.88258 15.3679 8.4087 16 10 16ZM6.25 9.25H13.75V10.75H6.25V9.25Z"
        fill="#DF1C41"
      />
    </svg>
  );
};
const UnBlock = ({ ...rest }) => {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M10 17.5C5.85775 17.5 2.5 14.1423 2.5 10C2.5 5.85775 5.85775 2.5 10 2.5C14.1423 2.5 17.5 5.85775 17.5 10C17.5 14.1423 14.1423 17.5 10 17.5ZM10 16C11.5913 16 13.1174 15.3679 14.2426 14.2426C15.3679 13.1174 16 11.5913 16 10C16 8.4087 15.3679 6.88258 14.2426 5.75736C13.1174 4.63214 11.5913 4 10 4C8.4087 4 6.88258 4.63214 5.75736 5.75736C4.63214 6.88258 4 8.4087 4 10C4 11.5913 4.63214 13.1174 5.75736 14.2426C6.88258 15.3679 8.4087 16 10 16ZM6.25 9.25H13.75V10.75H6.25V9.25Z"
        fill="#38C793"
      />
    </svg>
  );
};

const LanguageSwitcher = ({ ...rest }) => {
  return (
    <svg
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clip-path="url(#clip0_1040_8999)">
        <path
          d="M11.8175 15.071L11.165 17H9.5L12.293 9.5H14.219L17 17H15.2495L14.597 15.071H11.8175ZM14.2685 13.967L13.25 10.934H13.1765L12.158 13.967H14.27H14.2685Z"
          fill="#525866"
        />
        <path
          d="M5 8C5 7.20435 5.31607 6.44129 5.87868 5.87868C6.44129 5.31607 7.20435 5 8 5H18.5C19.2956 5 20.0587 5.31607 20.6213 5.87868C21.1839 6.44129 21.5 7.20435 21.5 8V12.5H26C26.7956 12.5 27.5587 12.8161 28.1213 13.3787C28.6839 13.9413 29 14.7044 29 15.5V26C29 26.7956 28.6839 27.5587 28.1213 28.1213C27.5587 28.6839 26.7956 29 26 29H15.5C14.7044 29 13.9413 28.6839 13.3787 28.1213C12.8161 27.5587 12.5 26.7956 12.5 26V21.5H8C7.20435 21.5 6.44129 21.1839 5.87868 20.6213C5.31607 20.0587 5 19.2956 5 18.5V8ZM8 6.5C7.60218 6.5 7.22064 6.65804 6.93934 6.93934C6.65804 7.22064 6.5 7.60218 6.5 8V18.5C6.5 18.8978 6.65804 19.2794 6.93934 19.5607C7.22064 19.842 7.60218 20 8 20H18.5C18.8978 20 19.2794 19.842 19.5607 19.5607C19.842 19.2794 20 18.8978 20 18.5V8C20 7.60218 19.842 7.22064 19.5607 6.93934C19.2794 6.65804 18.8978 6.5 18.5 6.5H8ZM18.707 21.4925C18.9965 21.944 19.31 22.367 19.652 22.7615C18.53 23.624 17.1425 24.263 15.5 24.6995C15.767 25.025 16.1765 25.652 16.3325 26C18.02 25.4615 19.4525 24.734 20.6615 23.759C21.827 24.7565 23.27 25.5065 25.0565 25.967C25.256 25.586 25.6775 24.9575 26 24.632C24.3125 24.2525 22.9145 23.591 21.77 22.706C22.7915 21.5855 23.603 20.2295 24.2015 18.5705H26V17H21.5V18.5705H22.6475C22.1705 19.8365 21.5375 20.8895 20.7395 21.7655C20.5191 21.5307 20.3113 21.2843 20.117 21.0275C19.6937 21.2989 19.2087 21.4589 18.707 21.4925Z"
          fill="#525866"
        />
      </g>
      <defs>
        <clipPath id="clip0_1040_8999">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(5 5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export default Clock;
export { RightArrow, Block, Dots, UnBlock, LanguageSwitcher };
